import {axios} from "~/plugins/axios";

const getDefaultState_projects = () => {
  return {
    projects: [],
    agents: [],
    dictionaries: [],
    queues: [],
    locations: [],
    groups: [],

  }
}
const state = getDefaultState_projects();

const getters = {
  projects: state => state.projects,
  queues: state => state.queues,
  dictionaries: state => state.dictionaries,
  //dictionaries_excluded: state => state.dictionaries,
  agents: state => state.agents,
  locations: state => state.locations,
  groups: state => state.groups,
  filteredQueues: state => projectsIds => {
    return state.queues.filter(q => projectsIds.includes(parseInt(q.project_id)))
  },
  filteredAgents: state => {
    return state.agents
    // return state.agents.filter(a => locationsIds.includes(a.location_id))
  }
}

const actions = {
  async loadProjects({commit}, params) {
    commit('shared/SET_LOADING', true, {root: true});

    await axios.get('/api/me/projects', {params: params})
      .then(response => {
        commit('SET_PROJECTS', response.data.data);
        if (params && params.with && params.with.includes('queues')) commit('ADD_PROJECT_TO_QUEUES');
        commit('shared/SET_LOADING', false, {root: true});
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        commit('shared/SET_LOADING', false, {root: true});
      });
  },
  async loadAgents({commit}, params) {
    commit('shared/SET_LOADING', true, {root: true});

    await axios.get('/api/me/agents', {params: params?.query})
      .then(response => {
        if (params?.clear) {
          let clearAgents = response.data.data;
          clearAgents = clearAgents.filter(a => !!a.sip_number);
          commit('SET_AGENTS', clearAgents);
        } else {
          commit('SET_AGENTS', response.data.data);
        }
        commit('shared/SET_LOADING', false, {root: true});
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true})
        commit('shared/SET_LOADING', false, {root: true});

        console.error(error);
      });
  },
  async loadQueues({commit}) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let resp = await axios.get('/api/me/queues')
      commit('SET_QUEUES', resp.data.data)
      commit('shared/SET_LOADING', false, {root: true})
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },
  async loadDictionaries({commit}) {
    try {
      let resp = await axios.get('/api/oline-voicer/matching/dictionaries')
      commit('SET_DICTIONARIES', resp.data.data)
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})

      throw err
    }
  },
  async loadLocations({commit}, params) {
    commit('shared/SET_LOADING', true, {root: true});

    await axios.get('/api/me/locations', {params: params})
      .then(response => {
        commit('SET_LOCATIONS', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        commit('shared/SET_LOADING', false, {root: true});
      });
  },
  async loadGroups({commit}) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let resp = await axios.get('/api/groups')
      let groups = resp.data.data.filter(group => group.members_ids.length > 0)
      commit('SET_GROUPS', groups)
      commit('shared/SET_LOADING', false, {root: true})
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

}


const mutations = {
  SET_PROJECTS(state, payload) {
    state.projects = payload;
  },
  ADD_PROJECT_TO_QUEUES(state) {
    try {
      state.queues = state.projects.map((p) => p.queues.map(q => ({
        ...q,
        project_name: p.name,
        project_id: p.id,
      }))).flat()
    } catch (e) {
      console.log(e)
    }
  },
  SET_AGENTS(state, payload) {
    state.agents = payload
  },
  SET_DICTIONARIES(state, payload) {
    state.dictionaries = payload
  },
  SET_QUEUES(state, payload) {
    state.queues = payload
  },
  SET_LOCATIONS(state, payload) {
    state.locations = payload
  },
  SET_GROUPS(state, payload) {
    state.groups = payload;
  },


  RESET_STATE_PROJECTS (state) {
    Object.assign(state, getDefaultState_projects())
  },
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
